(function () {
  'use strict';CancellationController.$inject = ["iziToast", "$anchorScroll", "$state", "UserService", "$window", "$analytics", "Intercom", "$http", "$location", "Profile", "gplansConf"];

  angular.
  module('gplans.store.controllers').
  controller('CancellationController', CancellationController);

  CancellationController.$inject = ['iziToast', '$anchorScroll', '$state', 'UserService', '$window', '$analytics',
  'Intercom', '$http', '$location', 'Profile', 'gplansConf'];

  /**
                                                               * @namespace UpdatePaymentController
                                                               */
  function CancellationController(iziToast, $anchorScroll, $state, UserService, $window, $analytics, Intercom,
  $http, $location, Profile, gplansConf) {
    var vm = this;
    vm.user = UserService.data;
    vm.year = new Date().getFullYear();
    vm.step = 0;
    vm.reason = "0";
    vm.reasonDescription = "";
    vm.feedback = null;
    vm.showPhone = false;
    vm.urls = {};
    vm.call = {};
    vm.pickerOpened = false;
    var moment = require("moment-timezone");
    vm.currentTimezone = moment.tz.guess();
    vm.dateOptions = {
      minDate: moment() };

    vm.allowSelfCancellation = UserService.data.subscription_plan && (


    UserService.data.subscription_plan.slug.includes('power') ||
    UserService.data.subscription_plan.slug.includes('annual') ||


    UserService.data.sunbasket_subscription.status !== 'active' &&
    UserService.data.subscription_plan.trial_price !== null &&
    new Date() - new Date(UserService.data.subscription.created_at) < 7 * 24 * 3600 * 1000
    // # todo 7 days trials only here ^
    );

    vm.reasonMap = {
      0: 'I can\'t afford it',
      1: 'I am not losing weight',
      2: 'I did not use it',
      3: 'It is not what I expected' };


    activate();

    function activate() {
      var timerTime = "10:01";
      var interval = setInterval(function () {
        var timer = timerTime.split(':');
        //by parsing integer, I avoid all extra string processing
        var minutes = parseInt(timer[0], 10);
        var seconds = parseInt(timer[1], 10);
        --seconds;
        minutes = seconds < 0 ? --minutes : minutes;
        if (minutes < 0) clearInterval(interval);
        seconds = seconds < 0 ? 59 : seconds;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        //minutes = (minutes < 10) ?  minutes : minutes;
        vm.time = minutes + 'min ' + seconds + 'sec';
        timerTime = minutes + ':' + seconds;
      }, 1000);
      $http.get(gplansConf.API_URL + '/api/snippets/get-urls/').then(function (res) {
        vm.urls = res.data;
      });
      var nowPst = moment().tz("America/Los_Angeles");
      if (nowPst.hour() >= 9 && nowPst.hour() < 17 && nowPst.day() >= 1 && nowPst.day() <= 5) vm.showPhone = true;
      var now = new Date();
      vm.callTimeMin = moment.tz("".concat(now.getMonth() + 1, "/").concat(now.getDate(), "/").concat(now.getFullYear(), " 09:00"), "MM/DD/YYYY HH:mm", "America/Los_Angeles").tz(vm.currentTimezone);
      vm.callTimeMax = moment.tz("".concat(now.getMonth() + 1, "/").concat(now.getDate(), "/").concat(now.getFullYear(), " 16:00"), "MM/DD/YYYY HH:mm", "America/Los_Angeles").tz(vm.currentTimezone);
      vm.call.time = new Date(vm.callTimeMin);
    }

    vm.incrementHours = function () {
      vm.call.time.setHours(vm.call.time.getHours() + 1);
      if (vm.call.time.getTime() > new Date(vm.callTimeMax).getTime()) {
        vm.call.time = new Date(vm.callTimeMin);
      }
    };

    vm.decrementHours = function () {
      vm.call.time.setHours(vm.call.time.getHours() - 1);
      if (vm.call.time.getTime() < new Date(vm.callTimeMin).getTime()) {
        vm.call.time = new Date(vm.callTimeMax);
      }
    };

    vm.incrementMinutes = function () {
      vm.call.time.setMinutes(vm.call.time.getMinutes() + 15);
      if (vm.call.time.getTime() > new Date(vm.callTimeMax).getTime()) {
        vm.call.time = new Date(vm.callTimeMin);
      }
    };

    vm.decrementMinutes = function () {
      vm.call.time.setMinutes(vm.call.time.getMinutes() - 15);
      if (vm.call.time.getTime() < new Date(vm.callTimeMin).getTime()) {
        vm.call.time = new Date(vm.callTimeMax);
      }
    };

    vm.dateDisabled = function (date, mode) {
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    };

    vm.openPicker = function () {
      vm.pickerOpened = true;
    };

    vm.sendCallRequest = function () {
      var date = "".concat(vm.call.date.getMonth() + 1, "/").concat(vm.call.date.getDate(), "/").concat(vm.call.date.getFullYear());
      var time = "".concat(vm.call.time.getHours(), ":").concat(vm.call.time.getMinutes());
      var callTime = moment.tz("".concat(date, " ").concat(time), "MM/DD/YYYY HH:mm", vm.currentTimezone).tz("America/Los_Angeles").format("MM/DD/YYYY hh:mm A");
      if (new Date(callTime).getDay() === 0 || new Date(callTime).getDay() === 6) {
        alert('This date is on weekend in PST time. Please, choose another date.');
        return;
      }
      $http.post(gplansConf.API_URL + '/api/call-request/', { call_time: callTime, phone: vm.call.phone }).then(
      function (res) {
        iziToast.show({
          message: 'Successful' });

        $state.go('gplans.userConsole.overview', {}, { reload: true });
      }, function (err) {
        iziToast.show({
          title: 'Error',
          message: err.data.error,
          backgroundColor: 'red' });

      });
    };

    vm.cancel = function () {
      var url = vm.urls['CancelSubscriptionAction'];
      var params = { pl: url.payload };
      $http.get(gplansConf.API_URL + url.url, { params: params }).then(function (res) {
        if (res.data.state == 'success') {
          vm.step = 3;
          iziToast.show({
            message: 'Successful Cancellation' });

        } else {
          iziToast.show({
            title: 'Error',
            message: res.data.error.message,
            backgroundColor: 'red' });

        }
      }, function (err) {
        iziToast.show({
          title: 'Error',
          message: err.data.error,
          backgroundColor: 'red' });

      }).catch(function (err) {
        iziToast.show({
          title: 'Error',
          message: err,
          backgroundColor: 'red' });

      });
    };

    vm.reduce = function () {
      var url = vm.urls['DiscountedSubscriptionAction'];
      var params = { pl: url.payload };
      $http.get(gplansConf.API_URL + url.url, { params: params }).then(function (res) {
        if (res.data.state == 'success') {
          iziToast.show({
            message: 'Successful Update' });

          vm.step = 4;
        } else {
          iziToast.show({
            title: 'Error',
            message: res.data.error.message,
            backgroundColor: 'red' });

        }
      }, function (err) {
        iziToast.show({
          title: 'Error',
          message: err.data.error,
          backgroundColor: 'red' });

      }).catch(function (err) {
        iziToast.show({
          title: 'Error',
          message: err,
          backgroundColor: 'red' });

      });
    };

    vm.gotoAnchor = function () {
      $anchorScroll();
    };

    vm.gotoAnchorTrial = function () {
      var payload = { text: vm.reasonDescription, reason: vm.reasonMap[vm.reason] };
      $http.post(gplansConf.API_URL + '/api/trial-cancel-feedback/', payload).then(function (res) {
        if (res.data.state == 'success') {
        } else {
          iziToast.show({
            title: 'Error',
            message: res.data.error.message,
            backgroundColor: 'red' });

        }
      }, function (err) {
        iziToast.show({
          title: 'Error',
          message: err.data.error,
          backgroundColor: 'red' });

      }).catch(function (err) {
        iziToast.show({
          title: 'Error',
          message: err,
          backgroundColor: 'red' });

      });
      $anchorScroll();
    };

    vm.postpone = function () {
      var url = vm.urls['PostponeUserSubscriptionAction'];
      var params = { pl: url.payload };
      $http.get(gplansConf.API_URL + url.url, { params: params }).then(function (res) {
        if (res.data.state == 'success') {
          iziToast.show({
            message: 'Successful' });

          $state.go('gplans.userConsole.overview', {}, { reload: true });
        } else {
          iziToast.show({
            title: 'Error',
            message: res.data.error.message,
            backgroundColor: 'red' });

        }
      }, function (err) {
        iziToast.show({
          title: 'Error',
          message: err.data.error,
          backgroundColor: 'red' });

      }).catch(function (err) {
        iziToast.show({
          title: 'Error',
          message: err,
          backgroundColor: 'red' });

      });
    };

    vm.feedbackPostpone = function () {
      var url = vm.urls['PostponeUserSubscriptionAction'];
      var params = { pl: url.payload };
      $http.get(gplansConf.API_URL + url.url, { params: params }).then(function (res) {
        if (res.data.state == 'success') {
          $http.post(gplansConf.API_URL + '/api/feedback/', { text: vm.feedback }).finally(function () {
            $state.go('gplans.userConsole.overview', {}, { reload: true });
          });
          iziToast.show({
            message: 'Successful' });

        } else {
          iziToast.show({
            title: 'Error',
            message: res.data.error.message,
            backgroundColor: 'red' });

        }
      }, function (err) {
        iziToast.show({
          title: 'Error',
          message: err.data.error,
          backgroundColor: 'red' });

      }).catch(function (err) {
        iziToast.show({
          title: 'Error',
          message: err,
          backgroundColor: 'red' });

      });
    };
  }
})();